import { Popover } from "radix-ui";
import { RiUser3Line } from "react-icons/ri";

import { useGetWhoami } from "@/api/whoami/get-whoami";
import { IconButton } from "@/components/atoms/IconButton";
import { useCurrentTenantName } from "@/hooks/use-current-tenant-name";
import { usePersistResetContext } from "@/hooks/use-persist-reset-context";
import { handleSignOut } from "@/lib/aws-amplify/auth";

const ROLE_LABEL = {
  host: "ホスト",
  admin: "管理者",
  member: "メンバー",
} as const;

const AccountPopoverContent = () => {
  const { name, email, role } = useGetWhoami();
  const tenantName = useCurrentTenantName();

  const resetPersist = usePersistResetContext();

  const handleClickSignOut = async () => {
    try {
      await resetPersist();
    } catch (e) {
      console.warn("[persist] removeClient failed; proceed to sign out", e);
    }

    try {
      await handleSignOut();
    } catch (error) {
      console.error("error signing out:", error);
    } finally {
      window.location.assign("/");
    }
  };

  return (
    <>
      <div className="border-b border-gray-100 p-4">
        <p className="text-Large font-bold">{name ?? ""}</p>
        <p className="text-Medium">{email ?? ""}</p>
      </div>

      <div className="space-y-2 border-b border-gray-100 p-4">
        <dl>
          <dt className="text-Small text-gray-500">ロール</dt>
          <dd className="text-Medium">{ROLE_LABEL[role]}</dd>
        </dl>
        {tenantName ? (
          <dl>
            <dt className="text-Small text-gray-500">テナント</dt>
            <dd className="text-Medium">{tenantName}</dd>
          </dl>
        ) : null}
      </div>

      <button
        type="button"
        className="block w-full p-4 text-left hover:bg-primary-50"
        onClick={() => void handleClickSignOut()}
      >
        <span className="text-Medium">ログアウト</span>
      </button>
    </>
  );
};

export const AccountPopover = () => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <IconButton variant="noBgPrimary" size="small" ariaLabel="アカウント">
          <RiUser3Line size={20} />
        </IconButton>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          className="w-65 rounded-sm border border-gray-100 bg-white shadow-lg will-change-[transform,opacity] data-[state=open]:data-[side=bottom]:animate-slide-down-and-fade data-[state=open]:data-[side=left]:animate-slide-right-and-fade data-[state=open]:data-[side=right]:animate-slide-left-and-fade data-[state=open]:data-[side=top]:animate-slide-up-and-fade"
          sideOffset={8}
          align="end"
        >
          <AccountPopoverContent />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
